import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { PaletizacionForm } from "./components/PaletizacionForm";
import "./styles/DetallePaletizacion.css";

class DetallePaletizacion extends Component {
    state = {
        idPaletizacion: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idPaletizacion = match.params.id_paletizacion;
        this.setState({ idPaletizacion });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Detalle de paletización"
                    subtitulo=""
                    col="12"
                >
                    <PaletizacionForm
                        idPaletizacion={this.state.idPaletizacion}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(DetallePaletizacion);
